export default "__VITE_ASSET__BL8XUEnQ__"